<div style="padding-bottom: 50px;margin-top: 5px;">
    <div class="otp_pad" [ngStyle]="{'width': (100/otpLength) + '%' }" *ngFor="let item of items;index as i">
        <input id="{{elementIds.otp_num+(i+1)}}" autocomplete="off" type="number" class="number en"
            (keypress)="localService.isNumberOnly($event,numericConfig)" [(ngModel)]="item.key"
            (keyup)="onFocus(i+1,$event)" (input)="onInput($event)" />
    </div>
</div>